import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
import { TESTIMONIALS } from './salesData';
export function TestimonialsSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-178" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-5xl px-5" data-id="element-179" data-mp="1mzisazlukbk2">
        <h2 className="text-center font-display text-[1.7rem] font-semibold text-charcoal sm:text-[2.2rem]" data-id="element-180" data-mp="1r1dwcbv5x31j">
          Experiencias de profesionales del bienestar
        </h2>
        <div className="mt-7 grid gap-3 sm:grid-cols-3" data-id="element-181" data-mp="1d47dkhafv4cb">
          {TESTIMONIALS.map((t, i) => <motion.div key={t.initials} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} data-id="element-182" data-mp="1hyl4a6e5onan" data-mpi={i}>
              <TestimonialCard t={t} data-id="element-183" data-mp="2yd354ralzfc5" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}